import { render, staticRenderFns } from "./single-choice-submitted-preview.vue?vue&type=template&id=138304ed&scoped=true&"
import script from "./single-choice-submitted-preview.vue?vue&type=script&lang=js&"
export * from "./single-choice-submitted-preview.vue?vue&type=script&lang=js&"
import style0 from "./single-choice-submitted-preview.vue?vue&type=style&index=0&id=138304ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138304ed",
  null
  
)

component.options.__file = "single-choice-submitted-preview.vue"
export default component.exports